import { useQuery, useQueryClient } from "@tanstack/react-query";
import { UUID } from "crypto";
import { useNavigate } from "react-router-dom";

import { getBrainDataKey } from "@/lib/api/brain/config";
import { useBrainApi } from "@/lib/api/brain/useKnowledgeBaseApi";

type UseBrainFetcherProps = {
  brainId?: UUID | null;
};

export const useBrainFetcher = ({ brainId }: UseBrainFetcherProps) => {
  const { getKnowledgeBase } = useBrainApi();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const fetchBrain = async () => {
    try {
      if (!brainId) {
        return undefined;
      }

      return await getKnowledgeBase(brainId);
    } catch {
      navigate("/studio");
    }
  };

  const { data: brain, isLoading } = useQuery({
    queryKey: brainId ? [getBrainDataKey(brainId)] : [],
    queryFn: fetchBrain,
    enabled: !!brainId,
  });

  const invalidateBrainQuery = () => {
    void queryClient.invalidateQueries({
      queryKey: brainId ? [getBrainDataKey(brainId)] : [],
    });
  };

  return {
    brain,
    refetchBrain: invalidateBrainQuery,
    isLoading,
  };
};
